import { createUseRBAC } from 'features/Auth/utils/hooks/useRBAC'

export const VendorSKPInfoRBAC = {
  pageID: 'ebdd3b65e0c340b339d8794fc725543b',
  elementID: {
    ViewVendorSKPInfo: '15d02ced6c07630fd29d59da7826d2fc',
    EditVendorSKPButton: 'a3e8660c4af96826f8f5cb2e60762d63',
  },
} as const
export const useVendorSKPInfoRBAC = createUseRBAC(VendorSKPInfoRBAC.elementID)

export type UseVendorSKPInfoRBACType = ReturnType<typeof useVendorSKPInfoRBAC>
export const VMSVendorInvoicesListRBAC = {
  pageID: 'dd83e441bec340b3397e3a43e1c4cae8',
  elementID: {
    ViewInvoiceList: '1172f9bc5638190b8aa8d9255b33ea74',
    ReviewInvoice: 'e5f5602f94b693190d10a1146a166815',
    ChangeInvoiceDueDate: '5ab493b51f48219ccd5cbc0c57715a8a',
  },
} as const
export const useRBACVMSVendorInvoicesListPage = createUseRBAC(VMSVendorInvoicesListRBAC.elementID)
export type UseRBACVMSVendorInvoicesListPageType = ReturnType<
  typeof useRBACVMSVendorInvoicesListPage
>

export const VMSVendorInvoiceReviewRBAC = {
  pageID: '3ee0d46eda3bb7661944d374c7461c2c',
  elementID: {
    ViewInvoiceReview: '0dc3796be48792ac6b75100cf6fcac7c',
    ApproveRejectInvoice: '138bf5810b9538cb2978c2857d22abb7',
    DowmnloadInvoiceFile: 'af10d2f9ebf0bdef48c6545a14828a5e',
    ChangeInvoiceDueDate: 'f0d7c78543be76b1ce4a81cbe133f1fd',
    StartInvoiceReview: '7c12ed44bd6a69d5fc321af619db9e69',
  },
} as const
export const useRBACVMSVendorInvoiceReviewPage = createUseRBAC(VMSVendorInvoiceReviewRBAC.elementID)
export type UseRBACVMSVendorInvoiceReviewPageType = ReturnType<
  typeof useRBACVMSVendorInvoiceReviewPage
>

export const ProductVendorsRBAC = {
  pageID: 'a819db24e7da69fba23849eaa94dfb6f',
  elementID: {
    ViewProductVendors: 'ce021a4fc71c5f5df20792e38b27f416',
    ChangeMainVendor: '2bae7ecb4ce67588e687ab33508000fa',
    DeleteVendor: 'c913823d0942df6ef730b04d567bf3e0',
    UpsertVendor: '9a12ce210f3dcd80b80cff628cb654e8',
  },
} as const
export const useRBACProductVendorsPage = createUseRBAC(ProductVendorsRBAC.elementID)
export type UseRBACProductVendorsPageType = ReturnType<typeof useRBACProductVendorsPage>

export const ProductVendorsUpsertRBAC = {
  pageID: '37aca149bab7083aeebec4ef03b8c615',
  elementID: {
    ViewProductVendorUpsert: '63a027671be4c2f07654f356da342934',
  },
} as const
export const useRBACProductVendorsUpsertPage = createUseRBAC(ProductVendorsUpsertRBAC.elementID)
export type UseRBACProductVendorsUpsertPageType = ReturnType<typeof useRBACProductVendorsUpsertPage>

export const VMSVendorListRBAC = {
  pageID: 'cbdae238bd37309dab6758e379667287',
  elementID: {
    ViewApprovalList: '95f86020935e8b662b690457ce3bbb89',
    ViewVendorReview: '5a0da4bff352131a541fa10bf8812daa',
    AddVendor: 'c214497ba88029b4433a63b1738e33b6',
    ReviewDocument: '6af85bb76bfe0d604985d006dcab57a0',
    ViewVendorList: '47739c11a6a9cc4c0e51dfb655e4a726',
    ViewVendorDetails: '165e604672fd816582ad650c2d4fa78c',
    EditVendor: '3cda2d0d08b335cd7f9af90ccbb0e1f5',
    EditVendorRequest: '22e9e46a3ba0950ed45fae6c8519c100',
    BulkUploadVendorMaster: '78d13686f110fdb862ba0ad85cb560e0',
    BulkUploadProductCataloging: '4be7901213b8e574adb89fb3da68bb76',
    UpdatePortalLogin: '5c415ef4ed59e593cf2c7d5d4b084aed',
    ApprovalLv1: 'dd62a2b622a423a8e0ba793631923bd1',
    ApprovalLv2: 'dd62a2b622a423a8e0ba793631923bd2',
    ApprovalLv3: 'dd62a2b622a423a8e0ba793631923bd3',
    ApprovalLv4: 'dd62a2b622a423a8e0ba793631923bd4',
    UpdateInfoSKP: '3324247445dfc4eb43aa6f4576bebe66',
    ViewPrincipalList: '197094b6b77427b92e7bbd6fe9a74542',
    AddPrincipal: 'b2039176c453cd06e0dd68cd7da1cb42',
  },
} as const
export const useRBACVMSVendorListPage = createUseRBAC(VMSVendorListRBAC.elementID)
export type UseRBACVMSVendorListPageType = ReturnType<typeof useRBACVMSVendorListPage>

export const VMSAddVendorRBAC = {
  pageID: '2832e4b12b8f3565f6f0f9ad3b07bd64',
  elementID: {
    ViewAddVendor: '7922e882ae785965a9d3db0878ea96ee',
  },
} as const
export const useRBACVMSAddVendorPage = createUseRBAC(VMSAddVendorRBAC.elementID)
export type UseRBACVMSAddVendorPageType = ReturnType<typeof useRBACVMSAddVendorPage>

export const VMSVendorDetailsUpsertRBAC = {
  pageID: '08f8061b5049a48300e7fa4dd275caa2',
  elementID: {
    ViewVendorDetailsUpsert: '220aec4baf57a618eac3887369d2ad66',
    EditVendor: 'bfcf02e8f00e9c4f2ae99e87a26f4a28',
    CancelDocument: '8b7dc5a5dc45af830b5e289598d04f6f',
  },
} as const
export const useRBACVMSVendorDetailsUpsertPage = createUseRBAC(VMSVendorDetailsUpsertRBAC.elementID)
export type UseRBACVMSVendorDetailsUpsertPageType = ReturnType<
  typeof useRBACVMSVendorDetailsUpsertPage
>

export const VendorBrandGroupRBAC = {
  pageID: 'cbcb27560e3f08e0be9d1d435c34c413',
  elementID: {
    ViewVendorBrandGroup: '39128140b7a8b5864afa24effa545912',
    CreateVendorBrandGroup: 'e9de2d97edbfd70465d46b2cc8adad91',
    EditVendorBrandGroup: '4efa01c4ac14c0ae881ad2362a29bbcd',
    BulkUploadVendorBrandGroup: '3a07edc4642352aa5cc91c790dd900b6',
  },
} as const
export const useRBACVendorBrandGroupPage = createUseRBAC(VendorBrandGroupRBAC.elementID)
export type UseRBACVendorBrandGroupPageType = ReturnType<typeof useRBACVendorBrandGroupPage>

export const VMSAddPrincipalRBAC = {
  pageID: '0813c7ebab81877db317a2b44bb554a0',
  elementID: {
    ViewAddPrincipal: '906fd9429aaf0035f4106fbaee6a08ae',
  },
} as const
export const useRBACVMSAddPrincipalPage = createUseRBAC(VMSAddPrincipalRBAC.elementID)
export type UseRBACVMSAddPrincipalPageType = ReturnType<typeof useRBACVMSAddPrincipalPage>

export const VMSEditPrincipalRBAC = {
  pageID: 'c3e8754c5a5c176fd02329972887f7e9',
  elementID: {
    ViewEditPrincipal: '2c85a5e4352ae1c233e158bc6444c904',
  },
} as const
export const useRBACVMSEditPrincipalPage = createUseRBAC(VMSEditPrincipalRBAC.elementID)
export type UseRBACVMSEditPrincipalPageType = ReturnType<typeof useRBACVMSEditPrincipalPage>

export const VMSDraftPrincipalRBAC = {
  pageID: '71037fdc1d752bd2cd00b867ad5aad98',
  elementID: {
    ViewEditPrincipal: '463cab202e866100235db732e309dad6',
  },
} as const
export const useRBACVMSDraftPrincipalPage = createUseRBAC(VMSDraftPrincipalRBAC.elementID)
export type UseRBACVMSDraftPrincipalPageType = ReturnType<typeof useRBACVMSDraftPrincipalPage>

export const VMSPrincipalReviewRBAC = {
  pageID: '3888258b23439b54cfa7af7b1bc6a41d',
  elementID: {
    ViewPrincipalReview: '662a27cf2e68f7f037abd1e190126a68',
    CancelProfileReview: 'ac1f53523068a55f01fdb446b591eaa7',
    ApproveProfileReview: '2910085a77bcd687694158198f9c0980',
    ReviewProfile: '8769fe0b7c51a60fc3056319ecd0efd0',
  },
} as const
export const useRBACVMSPrincipalReviewPage = createUseRBAC(VMSPrincipalReviewRBAC.elementID)
export type UseRBACVMSPrincipalReviewPageType = ReturnType<typeof useRBACVMSPrincipalReviewPage>

export const VendorPortalAccountsRBAC = {
  pageID: '840f3f7322dc047b87c67a05f4d911b4',
  elementID: {
    ViewVendorPortalAccounts: '105633b3100b0a8e596e800ed7fa5fc3',
    UpsertVendorAccount: 'e40704fc8cbd66e26e00f3fb8311b964',
  },
} as const
export const useRBACVendorPortalAccountsRBAC = createUseRBAC(VendorPortalAccountsRBAC.elementID)
export type UseRBACVendorPortalAccountsRBACType = ReturnType<typeof useRBACVendorPortalAccountsRBAC>
